import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBubble2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconBubble2"><Path d="M19.252 3C20.7707 3 22.002 4.23122 22.002 5.75V16.25C22.002 17.7688 20.7707 19 19.252 19H12.1946L7.36339 21.6572C7.13105 21.785 6.84849 21.7806 6.62023 21.6456C6.39198 21.5106 6.25195 21.2652 6.25195 21V19H4.75195C3.23317 19 2.00195 17.7688 2.00195 16.25V5.75C2.00195 4.23122 3.23317 3 4.75195 3H19.252Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBubble2;
